import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { ConfirmedValidator } from 'src/app/validators/ConfirmedValidator';

@Component({
  selector: 'app-change-password-component',
  templateUrl: './change-password-component.component.html',
  styleUrls: ['./change-password-component.component.less']
})
export class ChangePasswordComponentComponent {
  @Input() data;
  @Input() dialogRef;
  pwdGroup: FormGroup;
  hidePwd: Boolean[] = [true, true, true];

  constructor(private formBuilder: FormBuilder, private subscriberService: SubscriberService) {
    const reqex = ".{6,}";
    this.pwdGroup = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      password: ['', [Validators.required, Validators.pattern(reqex)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(reqex)]]
    }, {
      validator: ConfirmedValidator('password', 'confirmPassword')
    });
  }

  /** Change Password action */
  changePassword() {
    this.subscriberService.changePassword({
      oldPassword: this.pwdGroup.controls.oldPassword.value,
      newPassword: this.pwdGroup.controls.password.value
    }).then(resp => {
      // Change OTP Password during on boarding
      if (this.data) {
        this.subscriberService.changeOnBoarded().then((resp: any) => {
          this.dialogRef.close();
        });
      } else {
        location.hash = "#/account";
      }
    })
  }
}